<template>
    <div class="wrapper blog-post" id="top">
        <div class="page-header page-header-small" style="background:#183858b3;">
            <parallax class="page-header-image" :style="{'background-image': 'url('+article.headerimg+')'}"></parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-12 ml-auto mr-auto text-center">
                        <h1 class="title">{{article.title}}</h1>
                        <h4 style="margin-top:10px;">{{article.subheading}}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="button-container">
                            <a href="javascript:;" class="btn btn-primary btn-round btn-lg" style="pointer-events:none;">
                                {{displaydate}}
                            </a>
                            <a v-if="$route.query.admin == 'ETCa'" href="javascript:;" class="btn btn-danger btn-round btn-lg hide" @click="goEdit(article._id)">
                                Edit
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section" style="padding-bottom:0px;">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h3 class="title" v-if="article.heading !=null && article.heading !='' && article.heading !='<p></p>'" >{{article.heading}}</h3>
                            <div v-if="article.body !=null && article.body !='' && article.body !='<p></p>'" v-html="article.body">
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section-blog col-md-10 ml-auto mr-auto" style="padding-top:0px;">
                <div class="container">
                    <div class="section-story-overview">
                        
                        <div class="row">
                            
                            <div :class="{'col-md-6':article.img1 != '' && article.img2 != '','col-md-8 ml-auto mr-auto':article.img1 == '' || article.img2 == ''}" v-if="article.img1 != '' || article.img2 != ''">
                                <div class="image-container image-left" :class="{'image-not-left': article.img2 == '', 'image-not-left-no-quote': article.quote == ''}" v-if="article.img1 != ''" :style="{'background-image': 'url('+article.img1+')'}">
                                    <!-- First image on the left side -->
                                    <p class="blockquote blockquote-primary" :class="{'blockquote-not-left': article.img2 == ''}"  v-if="article.quote != ''" v-html="article.quote">
                                    </p>
                                </div>
                                <!-- Second image on the left side of the article -->
                                <div class="image-container image-left-bottom" v-if="article.img2 != '' && article.img2 != ''"
                                     :style="{'background-image': 'url('+article.img2+')'}">
                                </div>
                            </div>
                            <div :class="{'col-md-5':article.img1 != '' && article.img2 != '','col-md-8 ml-auto mr-auto':article.img1 == '' || article.img2 == ''}">
                                <!-- First image on the right side, above the article -->
                                <div class="image-container image-right" :class="{'img-not-right':article.img1 == '' || article.img2 == '' }" v-if="article.img3 != ''"
                                     :style="{'background-image': 'url('+article.img3+')'}">
                                </div>
                                <h3>
                                    {{article.heading2}}
                                </h3>
                                <div v-if="article.body2 !=null && article.body2 !='' && article.body2 !='<p></p>'" v-html="article.body2">
                                </div>
                            </div>
                            <div class="col-md-8 ml-auto mr-auto">
                                <div v-if="article.body3 !=null && article.body3 !='' && article.body3 !='<p></p>'" v-html="article.body3">
                                </div>
                                <a v-bind:href="article.linkto" class="btn btn-primary btn-lg" v-if="article.linktext != null && article.linktext != '' && article.linkto != null && article.linkto != '' && article.linkto.startsWith('http')">{{article.linktext}}</a>
                                <a href="javascript:;" class="btn btn-primary btn-lg" v-if="article.linktext != null && article.linktext != '' && article.linkto != null && article.linkto != '' && article.linkto.startsWith('/')" @click="gConversion(article.linkto)">{{article.linktext}}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section section-blog-info">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="blog-tags">
                                        Tags:
                                        <template v-for="(tag,index) in article.tags">
                                            <span :key="tag" :class="{'text-info': tag == 'Engineering', 'text-success': tag == 'Controls', 'text-danger': tag == 'Monitoring', 'text-warning': tag == 'Parts'}">{{tag}}</span>
                                            <span :key="index" v-if="index < article.tags.length -1">, </span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            <card type="profile" plain>
                                <template slot="raw-content">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="card-avatar">
                                                <img class="img img-raised" :src="article.authorimg">
                                                <div class="ripple-container"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-10">
                                            <h4 class="card-title">{{article.author}}</h4>
                                            <p class="description" v-html="article.authorquote"></p>
                                        </div>
                                    </div>
                                </template>
                            </card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
    import Contact from './components/Contact'
  import { Card } from '@/components';

    export default {
    name: 'blog-post',
    bodyClass: 'blog-post',
    components: {
        Contact,
        Card
    },
    
    data() {
      return {
        article: {
            _id: '',
            date: new Date(),
            tags: [],
            title: '',
            readmore: '',
            body: '',
            author: '',
            authorimg: '',
            style: 0,
            img1: '',
            img2: '',
            img3: '',
            thumbnail: '',
            heading: '',
            headerimg: '',
            subheading: '',
            body2: '',
            quote: '',
            authorquote: '',
            linkto: '',
            linktext: '',
            keywords:''
        },
        domain: 'https://api.website.gamsplus.systems',
        latest: null,
        submitMessage: '',
        loadingSubmit: false,
        
      }
    },
    metaInfo () {
        return {
            title: this.article.title,
            meta: [
                { vmid: 'description', name: 'description', content: this.article.readmore },
                { vmid: 'keywords', name: 'keywords', content: this.article.keywords }
            ],
            links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com/article?id='+this.article._id}
            ]
            
        }
    },
    created() {
        this.getArticle()
    },
    mounted() {
    },
    methods: {
        getLatest() {
            this.$http.post(this.domain+'/articles/latest',{
                    'title': this.article.title,
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
            })
        },
        getArticle() {
            this.$http.get(this.domain+'/articles/'+this.$route.query.id,{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                if(data.body == '' || data.body == null){
                    this.$router.push({ path: '/404' })
                } else {
                    this.article = data.body
                    setTimeout(() => {
                        this.getLatest()
                    }, 1000);
                    console.log('ARTICLE!!!')
                    console.log(this.article)
                    
                }
                
            })
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
        },
        goEdit(articleID) {
            this.$router.push({ path: '/article/edit', query: { id: articleID }})
        },
        gConversion(link){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
            this.$router.push(link)
        }
    },
    computed: {
        displaydate () {
            return new Date(this.article.date).toLocaleDateString("en-US")
        },
    },
    watch: {
        '$route' (to, from) {
            this.getArticle()
            
            
        }
    },
  }
</script>
<style scoped>
.section-story-overview .image-container:nth-child(2) {
    margin-top: 290px;
}
@media (max-width: 768px){
    h1.title{
        font-size:3em;
    }
    .section-story-overview .image-container:nth-child(2) {
        margin-top: 300px;
        margin-left: auto;
        margin-bottom: 30px;
    }
    .section-story-overview .image-container.image-right {
        margin-bottom: 50px;
    }
    .image-container.image-left p.blockquote {
        margin: 50px auto;
        position: relative;
        right: 0;
        top: 400px;
    }
    
}
@media screen and (min-width: 991px){
    h1.title{
        font-size:4em;
    }
}
@media screen and (max-width: 576px){
    h1.title{
        font-size:2.7em;
    }
}
.page-header input[type="text"] {
    color: white;
}
input[type="text"] {
    background: transparent;
    border: 0px;
}
textarea{
    width:100%;
    min-height:300px;
}
.img-not-right{
    margin-left: 0px !important;
    top: 50px !important;
    margin-bottom: 100px !important;
}
.image-container.image-not-left {
    margin-right: 0px;
    margin-bottom: 260px;
}
.image-container.image-not-left-no-quote {
    margin-right: 0px;
    margin-bottom: 30px;
}
.section-story-overview p.blockquote {
    width: 350px;
}
.section-story-overview p.blockquote-not-left {
    width: 100%;
    min-height: 180px;
    text-align: left;
    margin: 0 auto;
    position: relative;
    top: 400px;
    right: auto;
    z-index: 0;
}

</style>